import React from 'react';
import Popup from 'react-popup';

import AvailableDaysQuadrant from './AvailableDaysQuadrant';

Popup.registerPlugin('availaleDays', function plugin(driverIds = []) {
  this.create({
    title: `Quadrante de Dias Disponíveis: ${driverIds.length} Motorista(s)`,
    className: 'large-popup',
    content: (
      <AvailableDaysQuadrant
        driverIds={driverIds}
      />
    ),
  });
});


const availaleDays = (driverIds = []) => {
  Popup.plugins().availaleDays(driverIds);
};

export default availaleDays;



// WEBPACK FOOTER //
// ./src/Driver/availableDaysReport.popup.js